<app-enseignant-planning *ngIf="!loading; else loader" [idEnseignant]=idEnseignant [config]=config
  [coursList]="coursList" [preview]=false>
</app-enseignant-planning>

<ng-template #loader>
  <app-loader class="margin">Chargement en cours...</app-loader>
</ng-template>